import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
//import Maps from "views/Maps/Maps.js";
import Duongbo from "layouts/Duongbo.js";
import Vantaikhac from "layouts/Vantaikhac.js";
import Dashboard from "views/Dashboard/Dashboard.js";
import Quantri from "layouts/Quantri.js";
import Dashboardimg from "assets/img/dashboardmenu/dashboard.png";
import Duongboimg from "assets/img/dashboardmenu/oto.png";
import Vantaikhacimg from "assets/img/dashboardmenu/tau_thuy.png";
import Quantriimg from "assets/img/dashboardmenu/quantri.png";
import AddAlert from "@material-ui/icons/AddAlert";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import Modal from "@mui/material/Modal";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import Canhbaohethantable from "components/Canhbao/Canhbaohethantable.js";
import { Tooltip } from "@material-ui/core";
import Background from "assets/img/gtvt.jpg";
import Config from "conFig.js";
import { useIdleTimer } from "react-idle-timer";
import styles from "assets/jss/material-dashboard-react/components/homeMenu.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
const BlueOnGreenTooltip = withStyles({
  tooltip: { backgroundColor: "#c2c800" },
})(Tooltip);
export default function HomeComponent() {
  const [duongbo, setDuongbo] = React.useState(0);
  const [vantaikhac, setVantaikhac] = React.useState(0);
  const [dashboard, setDashboard] = React.useState(0);
  const [quantri, setQuantri] = React.useState(0);
  const [canhbaophuhieu, setCanhbaophuhieu] = React.useState("");
  const [phuhieu, setPhuhieu] = React.useState([]);
  const [canhbaohangpkd, setCanhbaohangpkd] = React.useState("");
  const [hangpkd, setHangpkd] = React.useState([]);
  const classes = useStyles();
  const timeout = 1800000;
  const [lastActive, setLastActive] = React.useState(+new Date());
  const [isIdle, setIsIdle] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => setIsIdle(true);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const { getLastActiveTime } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
  });
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const role = localStorage.getItem("role");
  const checkpermissionhome = (dashboard) => {
    var url =
      Config.backend +
      "/api/checkdashboard/checkdashboard?role=" +
      role +
      "&dashboard=" +
      dashboard;
    return fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return error;
      });
  };
  const gotoduongbo = () => {
    let check = checkpermissionhome("Duongbo");
    check.then((result) => {
      if (result === "1") setDuongbo(1);
      else showNotification();
    });
  };
  const gotovantaikhac = () => {
    let check = checkpermissionhome("Vantaikhac");
    check.then((result) => {
      if (result === "1") setVantaikhac(1);
      else showNotification();
    });
  };
  const gotodashboard = () => {
    let check = checkpermissionhome("Dashboard");
    check.then((result) => {
      if (result === "1") setDashboard(1);
      else showNotification();
    });
  };
  const gotoquantri = () => {
    let check = checkpermissionhome("Quantri");
    check.then((result) => {
      if (result === "1") setQuantri(1);
      else showNotification();
    });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 3000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 5000);
  };
  const autologout = () => {
    if (isIdle === true) {
      var d = +new Date();
      if (d - lastActive > 1800000) {
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("name");
        localStorage.removeItem("username");
        location.href = "/admin/login";
      }
    }
  };
  const getcanhbaophuhieu = () => {
    var url =
      Config.backend + "/api/canhbao/canhbaophuhieuxe?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          setPhuhieu(data);
          setCanhbaophuhieu(
            "Số lượng phù hiệu đã hết hạn : " + data.length + " "
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getcanhbaohangpkd = () => {
    var url =
      Config.backend + "/api/canhbao/canhbaohethangpdkkd?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        if (data.length > 0) {
          setHangpkd(data);
          setCanhbaohangpkd(
            "Số lượng GPDKKD đã hết hạn : " + data.length + " "
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const canhbaofunction = () => {
    if (canhbaophuhieu.length > 0 || canhbaohangpkd.length > 0) {
      showNotification1();
    }
  };
  React.useEffect(() => {
    setLastActive(getLastActiveTime());
    setInterval(() => {
      setLastActive(getLastActiveTime());
    }, 1800000);
  }, []);
  React.useEffect(() => {
    autologout();
  }, [isIdle]);
  React.useEffect(() => {
    getcanhbaophuhieu();
    getcanhbaohangpkd();
  }, []);
  React.useEffect(() => {
    canhbaofunction();
  }, [canhbaophuhieu, canhbaohangpkd]);
  if (duongbo === 1) {
    return (
      <Switch>
        <Route path="/admin" component={Duongbo} />
      </Switch>
    );
  }
  if (vantaikhac === 1) {
    return (
      <Switch>
        <Route path="/admin" component={Vantaikhac} />
      </Switch>
    );
  }
  if (dashboard === 1) {
    return (
      <Switch>
        <Route path="/admin/dashboard" component={Dashboard} />
        <Redirect from="/" to="/admin/dashboard" />
      </Switch>
    );
  }
  if (quantri === 1) {
    return (
      <Switch>
        <Route path="/admin" component={Quantri} />
      </Switch>
    );
  }
  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        height: "100%",
        position: "fixed",
        width: "100%",
        backgroundSize: "cover",
      }}
    >
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.left_main}>
            <div className={classes.md_col_12}>
              <GridContainer>
                <div className={classes.title_right_menu_home}>
                  <h3 className={classes.title_h3}>
                    HỆ THỐNG QUẢN LÝ HOẠT ĐỘNG VẬN TẢI
                  </h3>
                  <h3 className={classes.title_h3}>TỈNH GIA LAI</h3>
                </div>
              </GridContainer>
              <GridContainer>
                <div className={classes.content_cus}>
                  <div className={classes.content_cls}>
                    <div className={classes.col_md_6}>
                      <div className={classes.item_center}>
                        <BlueOnGreenTooltip
                          title={
                            <a className={classes.tooltip_home}>
                              Trang thông tin Dashboard
                            </a>
                          }
                          placement="top-start"
                        >
                          <a className={classes.img} onClick={gotodashboard}>
                            <img
                              className={classes.img_cls}
                              src={Dashboardimg}
                            />
                            <h4 className={classes.title_h4}>DASHBOARD</h4>
                          </a>
                        </BlueOnGreenTooltip>
                      </div>
                    </div>
                    <div className={classes.col_md_6}>
                      <div className={classes.item_center}>
                        <BlueOnGreenTooltip
                          title={
                            <a className={classes.tooltip_home}>
                              Quản lý đường bộ
                            </a>
                          }
                          placement="top-start"
                        >
                          <a className={classes.img} onClick={gotoduongbo}>
                            <img className={classes.img_cls} src={Duongboimg} />
                            <h4 className={classes.title_h4}>ĐƯỜNG BỘ</h4>
                          </a>
                        </BlueOnGreenTooltip>
                      </div>
                    </div>
                    <div className={classes.col_md_6}>
                      <div className={classes.item_center}>
                        <BlueOnGreenTooltip
                          title={
                            <a className={classes.tooltip_home}>
                              Quản lý đường thủy nội địa, cảng biển, đường sắt,
                              đường hàng không
                            </a>
                          }
                          placement="top-start"
                        >
                          <a className={classes.img} onClick={gotovantaikhac}>
                            <img
                              className={classes.img_cls}
                              src={Vantaikhacimg}
                            />
                            <FormControl
                              style={{
                                width: "100%",
                                marginTop: -30,
                                marginBottom: 20,
                              }}
                            >
                              <h4 className={classes.title_h4}>
                                CÁC PHƯƠNG THỨC VẬN TẢI
                              </h4>
                            </FormControl>
                          </a>
                        </BlueOnGreenTooltip>
                      </div>
                    </div>
                    <div className={classes.col_md_6}>
                      <div className={classes.item_center}>
                        <BlueOnGreenTooltip
                          title={
                            <a className={classes.tooltip_home}>
                              Trang quản trị
                            </a>
                          }
                          placement="top-start"
                        >
                          <a className={classes.img} onClick={gotoquantri}>
                            <img className={classes.img_cls} src={Quantriimg} />
                            <h4 className={classes.title_h4}>QUẢN TRỊ</h4>
                          </a>
                        </BlueOnGreenTooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </GridContainer>
            </div>
          </div>
        </GridItem>
        <GridItem xs={12} sm={10} md={12}>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <GridContainer>
                <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={6}>
                  <Card>
                    <CardHeader color="primary" style={{ height: 10 }}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={10}>
                          <FormControl
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <h6
                              className={classes.cardTitleWhite}
                              style={{ marginTop: "-5px" }}
                            >
                              Thông tin cảnh báo
                            </h6>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={1}></GridItem>
                        <GridItem xs={12} sm={12} md={1}>
                          <FormControl
                            style={{ width: "100%", marginTop: "1px" }}
                          >
                            <CloseIcon onClick={handleClose} />
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </CardHeader>
                    <Canhbaohethantable phuhieu={phuhieu} hangpkd={hangpkd} />
                  </Card>
                </GridItemLogin>
                <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              </GridContainer>
            </div>
          </Modal>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Bạn không được quyền sử dụng chức năng này"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <Snackbar
            className="fa fa-circle text-danger-glow"
            place="tc"
            color="warning"
            message={
              <div style={{ width: 300, textAlign: "center" }}>
                <i className="fa fa-circle text-danger-glow blink"></i>
                <span style={{ textAlign: "center" }}> Cảnh báo </span>
                <i className="fa fa-circle text-danger-glow blink"></i>
                <div>{canhbaophuhieu}</div>
                <div>{canhbaohangpkd}</div>
                <a
                  className={classes.canhbaochitiet}
                  onClick={() => setOpen(true)}
                >
                  Xem chi tiết
                </a>
              </div>
            }
            open={alert1}
            closeNotification={() => setAlert1(false)}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
